// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._9xJpvGTUuxwAzW0EzkAfwA\\=\\={width:100%}._9xJpvGTUuxwAzW0EzkAfwA\\=\\= p{font-size:14px}", "",{"version":3,"sources":["webpack://./src/components/TextBoxWidget/subcomponents/StaticTextBox.module.scss"],"names":[],"mappings":"AAAA,6BACE,UAAA,CAEA,+BACE,cAAA","sourcesContent":[".container {\n  width: 100%;\n\n  p {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_9xJpvGTUuxwAzW0EzkAfwA=="
};
export default ___CSS_LOADER_EXPORT___;
